function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9647 14.2549H15.7547L20.7447 19.2549L19.2547 20.7449L14.2547 15.7549V14.9649L13.9847 14.6849C12.8447 15.6649 11.3647 16.2549 9.75474 16.2549C6.16474 16.2549 3.25474 13.3449 3.25474 9.75488C3.25474 6.16488 6.16474 3.25488 9.75474 3.25488C13.3447 3.25488 16.2547 6.16488 16.2547 9.75488C16.2547 11.3649 15.6647 12.8449 14.6847 13.9849L14.9647 14.2549ZM5.25519 9.755C5.25519 12.245 7.26519 14.255 9.75519 14.255C12.2452 14.255 14.2552 12.245 14.2552 9.755C14.2552 7.265 12.2452 5.255 9.75519 5.255C7.26519 5.255 5.25519 7.265 5.25519 9.755Z",
  fill: "#F7F7F7"
});

var SvgSearchMobileIcon = function SvgSearchMobileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchMobileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-mobile-icon.fa8a7e9b.svg";
export { ForwardRef as ReactComponent };